import { Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import CultService from '../../Services/CultService';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../Utils/helper/HelperTexts';
import { useSelector } from 'react-redux';
import PageLoader from '../../Components/PageLoader';
import CallRecordingsList from './Components/CallRecordingsList';
import RecordingsFilter from './Components/RecordingsFilter';
import { App, DatePicker, Select } from 'antd';
import moment from 'moment';
import CampaignEmptyState from '../../Components/CampaignEmptyState';
import SelectCampaign from '../../Components/SelectCampaign';
import { DotIcon, InfoOutlineIcon } from '../../Components/Icons/Icons';
import { AppColors } from '../../Utils/helper/AppColors';
import { ColorContext } from '@mui/x-charts/internals';

const { RangePicker } = DatePicker;

export default function CallRecordings() {
	const company = useSelector((state) => state?.app?.company);
	const [loading, setLoading] = useState(false);
	const [filterQuery, setFilterQuery] = useState(null);
	const [recordings, setRecordings] = useState([]);
	const [campaigns, setCampaigns] = useState([]);
	const [dateFilter, setDateFilter] = useState(null);
	const [scoreFilter, setScoreFilter] = useState(null);

	const [pagination, setPagination] = useState({ count: 0, rowsPerPage: 10, page: 1 });

	const getRecordings = async (page = 1, limit = pagination?.rowsPerPage) => {
		setLoading(true);
		try {
			console.log('filterQuery', filterQuery);
			let res = await CultService.getCallRecordings({
				params: {
					companyId: company?._id,
					users: filterQuery?.users?.map((i) => i._id),
					campaigns: filterQuery?.campaigns?.map((i) => i._id),
					from : filterQuery?.date?.from,
					to : filterQuery?.date?.to,
					page: page,
					limit: limit,
				},
			});
			setRecordings(res?.data?.data?.recordings);
			setScoreFilter(null);

			// console.log();

			if (res?.data?.data?.recordings?.length) {
				setPagination({
					count: res?.data?.data?.totalRecords,
					rowsPerPage: limit,
					page: res?.data?.data?.currentPage,
				});
			}
		} catch (err) {
			toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const handleSelectCampaign = (i, option) => {
		// console.log('i;', i);   -> passed kay value
		// console.log('option;', option);  -> contains all about campaing and also key value childern from selct antd
		setFilterQuery((prev) => ({ ...prev, campaigns: [option?.item] }));
	};

	const getCampaings = async () => {
		try {
			let res = await CultService.getCampaignList({ params: { companyId: company?._id } });
			if (res.status == 200) {
				setCampaigns(res?.data);
			}
		} catch (err) {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
		}
	};

	const handleChange = (e, date) => {
		if (!e) {
			return setDateFilter(null);
		}
		let startDate = moment(new Date(e[0])).format();
		let endDate = moment(new Date(e[1])).format();
		setDateFilter({ ...dateFilter, startDate, endDate });
	};

	const filterArrayByDate = (array, dateFilter) => {
		if (!dateFilter || !dateFilter.startDate || !dateFilter.endDate) {
			return array;
		}
		const { startDate, endDate } = dateFilter;
		return array?.filter((item) => {
			const itemDate = new Date(item.call.createdAt);
			const start = new Date(startDate);
			const end = new Date(endDate);
			return itemDate >= start && itemDate <= end;
		});
	};

	useEffect(() => {
		if (company) {
			getCampaings();
			if (filterQuery?.campaigns?.length > 0) {
				getRecordings();
			}
		}
	}, [company, filterQuery]);

	const getScoreColor = (score) => {
		let res = AppColors.STATUS_GREY;
		if (score < 50) {
			res = AppColors.tomato_orange || AppColors.STATUS_RED;
		}
		if (score >= 40 && score <= 70) {
			res = AppColors.yellow || AppColors.STATUS_YELLOW;
		}
		if (score > 70) {
			res = AppColors.green || AppColors.STATUS_GREEN;
		}
		return res;
	};

	const handleScoreFilter = (type) => {
		setScoreFilter((prev) => (prev === type ? null : type));
	};

	const filterByScore = (items) => {
		if (!scoreFilter) return items;

		return items?.filter((item) => {
			const score = item?.callSummary?.score;

			if (scoreFilter === 'harassment') return item?.hasHarassmentTendencies;
			if (scoreFilter === 'suicidal') return item?.hasSuicidalTendencies;

			if (scoreFilter === 'urgent' && !item?.hasHarassmentTendencies && !item?.hasSuicidalTendencies) return score < 40;
			if (scoreFilter === 'review' && !item?.hasHarassmentTendencies && !item?.hasSuicidalTendencies)
				return score >= 40 && score <= 70;
			if (scoreFilter === 'stable' && !item?.hasHarassmentTendencies && !item?.hasSuicidalTendencies) return score > 70;
		});
	};

	console.log('filterQuery', filterQuery);
	

	return (
		<Stack sx={{ padding: 2 }}>
			{loading && <PageLoader />}
			<PageHeading title="Conversations" subTitle="Listen to and manage conversations" />
			<Stack mt={2} gap={2}>
				<Stack direction="column" gap={2}>
					<Stack direction="row" alignItems="center" gap={2}>
					<SelectCampaign handleSelectCampaign={handleSelectCampaign} />
					<RecordingsFilter campaigns={campaigns} setFilterQuery={setFilterQuery} />
                    </Stack>

					<Stack direction="row" alignItems="center" gap={5} ml={1} sx={{ overflowY : 'auto' ,  whiteSpace: { sm: 'normal', md: 'nowrap' }}
}  >
						<Stack sx={{ cursor: 'pointer' , disxplay : 'flex' , flexDirection : 'row', alignItems : 'center' , gap : 1 }}  onClick={() => handleScoreFilter('harassment')}>
							<InfoOutlineIcon color={AppColors.tomato_orange || AppColors.STATUS_HARASSMENT} />
							<Typography variant="subtitle2" fontSize={12}>
								Urgent Alert
							</Typography>
						</Stack>
						<Stack sx={{ cursor: 'pointer' , disxplay : 'flex' , flexDirection : 'row', alignItems : 'center' , gap : 1 }} onClick={() => handleScoreFilter('suicidal')}>
							<InfoOutlineIcon color={AppColors.yellow || AppColors.STATUS_SUICIDAL} />
							<Typography variant="subtitle2" fontSize={12}>
								immediate Attention
							</Typography>
						</Stack>

						<Stack sx={{ cursor: 'pointer' , disxplay : 'flex' , flexDirection : 'row', alignItems : 'center' , gap : 1 }} onClick={() => handleScoreFilter('urgent')}>
							<DotIcon size={16} color={getScoreColor(30)} />
							<Typography variant="subtitle2" fontSize={12}>
								Urgent
							</Typography>
						</Stack>
						<Stack sx={{ cursor: 'pointer' , disxplay : 'flex' , flexDirection : 'row', alignItems : 'center' , gap : 1 }} onClick={() => handleScoreFilter('review')}>
							<DotIcon size={16} color={getScoreColor(50)} />
							<Typography variant="subtitle2" fontSize={12}>
								Needs Review
							</Typography>
						</Stack>
						<Stack sx={{ cursor: 'pointer' , disxplay : 'flex' , flexDirection : 'row', alignItems : 'center' , gap : 1 }} onClick={() => handleScoreFilter('stable')}>
							<DotIcon size={16} color={getScoreColor(80)} />
							<Typography variant="subtitle2" fontSize={12}>
								Stable
							</Typography>
						</Stack>
					</Stack>
					{/* <RangePicker onChange={handleChange} style={{ marginLeft: 'auto' }} /> */}
				</Stack>
				{filterQuery?.campaigns?.length > 0 ? (
					<CallRecordingsList
						fetch={getRecordings}
						height="calc(100vh - 190px)"
						recordings={filterByScore(filterArrayByDate(recordings, dateFilter))}
						pagination={pagination}
					/>
				) : (
					<CampaignEmptyState text="Select a campaign to view conversations." />
				)}
			</Stack>
		</Stack>
	);
}
